import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import SearchResultHeader from "./SearchResultHeader";
import { getListingDetails } from "./ListingDetails";
import PersonSearchResult from "./PersonSearchResult";
import { getMenuItem } from "../common/PageHelper";

class PhoneNumberToNameResult extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    let recCount = 0;
    let tabHeader = null;
    let hasPersons;
    let criteria;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      const listingsRecord = _.get(
        this.props.searchResultData,
        `${
          Object.keys(this.props.searchResultData)[0]
        }.match[0].searchBy[0].listings[0]`
      );
      const log = _.get(
        this.props.searchResultData,
        `${Object.keys(this.props.searchResultData)[0]}.log[0]`
      );
      if (listingsRecord) {
        const records = _.get(listingsRecord, "listing");

        const orderedListings = _.orderBy(
          records,
          ["source[0]._", "addressType[0]._"],
          ["desc", "desc"]
        );

        const showNarrowSearchMessage = records && records.length > 25;
        tabHeader = (
          <SearchResultHeader
            showNarrowSearchMessage={showNarrowSearchMessage}
            log={log}
            {...this.props}
            printContent={this.props.printContent}
          />
        );

        if (orderedListings !== undefined) {
          _.forEach(orderedListings, (record, index) => {
            const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
            results.push(
              getListingDetails({
                node: record,
                colorClass,
                ...this.props,
                index,
              })
            );
          });
        }
      }
      recCount = results.length;
      if (results.length < 1) {
        results.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
      hasPersons = _.get(
        this.props.searchResultData,
        `${
          Object.keys(this.props.searchResultData)[0]
        }.match[0].searchBy[0].persons[0]`
      );
      const actDesc = _.get(log, "actDesc[0]");
      if (actDesc !== undefined)
        if (actDesc.indexOf("with") !== -1)
          criteria = actDesc.substring(0, actDesc.indexOf("with"));
        else criteria = actDesc;
    }
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${recCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          <Table stackable>
            <Table.Body>{results}</Table.Body>
          </Table>
          {hasPersons && (
            <PersonSearchResult
              {...this.props}
              isSubSection
              titleDesc={criteria}
              resultRootNodeName={`${
                Object.keys(this.props.searchResultData)[0]
              }`}
              searchResultData={_.get(
                this.props.searchResultData,
                `${
                  Object.keys(this.props.searchResultData)[0]
                }.match[0].searchBy`
              )}
            />
          )}
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(PhoneNumberToNameResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/PhoneNumberToNameResult.js